import {
  faCheck,
  faInfoCircle,
  faSearch,
  faWarning,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons'
import { type BoxProps } from '@mantine/core'
import clsx from 'clsx'
import { type PropsWithChildren } from 'react'

import { Icon as IconUI, type IconProps as IconUIProps } from '../../../@shared'
import type { ResultProps } from './Result'
import styles from './styles.module.css'

type IconProps = PropsWithChildren<BoxProps> & {
  icon?: IconUIProps['icon']
  color?: IconUIProps['color']
  variant?: ResultProps['variant']
}

const mapVariants = {
  info: {
    icon: faInfoCircle,
    color: 'gray',
  },
  warning: {
    icon: faWarning,
    color: 'orange',
  },
  error: {
    icon: faTimes,
    color: 'red',
  },
  success: {
    icon: faCheck,
    color: 'green',
  },
  empty: {
    icon: faSearch,
    color: 'yellow',
  },
}

export function Icon({
  color = 'gray',
  icon,
  variant = 'info',
  ...props
}: IconProps) {
  const iconInfo = {
    icon,
    color,
    testId: 'fa-icon-variant',
  }

  if (icon) {
    iconInfo.icon = icon
    iconInfo.testId = 'fa-icon'
  } else {
    iconInfo.icon = mapVariants[variant].icon
    iconInfo.color = mapVariants[variant].color
  }

  return (
    <IconUI
      icon={iconInfo.icon}
      color={iconInfo.color}
      bg={`${iconInfo.color}.0`}
      size='lg'
      data-testid={iconInfo.testId}
      withCircleBackground
      className={clsx(styles.icon, props.className)}
      {...props}
    />
  )
}
